// Shared "extend cursor to end of identifier" helper. Monaco fires F12 with
// the cursor mid-word, but the SR-RO dotted parser was designed for cursors
// at the END of a chain. We extend the offset to the right edge of the token
// under it before handing off, including bracketed/quoted identifiers that
// may contain spaces (mssql `[User Profile]`-style).
//
// PRD: Ralph/NavigationalFeatures/PRD.md § Slice 5 (table/view), Slice 6
// (column). Both find{TableView,Column}BindingAtCursor depend on this.

export function extendCursorToIdentEnd(source: string, offset: number): number {
  const len = source.length;
  const start = Math.max(0, Math.min(offset, len));

  const opener = findEnclosingOpener(source, start);
  if (opener) {
    const closer = opener.opener === '[' ? ']' : opener.opener;
    let i = opener.openerIndex + 1;
    while (i < len) {
      if (source[i] === closer) {
        // Doubled-quote escape for `"`/backtick — skip past the pair.
        if ((closer === '"' || closer === '`') && source[i + 1] === closer) {
          i += 2;
          continue;
        }
        return i + 1;
      }
      i++;
    }
    return len;
  }
  let i = start;
  while (i < len && /[A-Za-z0-9_$]/.test(source[i])) i++;
  return i;
}

function findEnclosingOpener(
  source: string,
  cursor: number,
): { opener: string; openerIndex: number } | null {
  let i = cursor;
  if (source[i] === '"' || source[i] === '`' || source[i] === '[') {
    return { opener: source[i], openerIndex: i };
  }
  while (i > 0) {
    const ch = source[i - 1];
    if (ch === '"' || ch === '`' || ch === '[') {
      return { opener: ch, openerIndex: i - 1 };
    }
    if (ch === ']' || ch === '\n' || ch === '\r' || ch === ';') return null;
    if (!/[A-Za-z0-9_$ \t]/.test(ch)) return null;
    i--;
  }
  return null;
}
